import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import PropTypes from "prop-types";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import SuiBox from "components/SuiBox";
import Breadcrumbs from "examples/Breadcrumbs";
import { navbar, navbarContainer, navbarRow } from "examples/Navbars/DashboardNavbar/styles";
import { useSoftUIController, setTransparentNavbar } from "context";
import SuiButton from "components/SuiButton";
import { Auth } from "aws-amplify";

function DashboardNavbar({ absolute, light, isMini, eventName }) {
  const [navbarType, setNavbarType] = useState();
  const [controller, dispatch] = useSoftUIController();
  const { transparentNavbar, fixedNavbar } = controller;
  const location = useLocation();
  const route = location.pathname.split("/").slice(1).map(segment => decodeURIComponent(segment));

  useEffect(() => {
    if (fixedNavbar) {
      setNavbarType("sticky");
    } else {
      setNavbarType("static");
    }

    function handleTransparentNavbar() {
      setTransparentNavbar(dispatch, (fixedNavbar && window.scrollY === 0) || !fixedNavbar);
    }

    window.addEventListener("scroll", handleTransparentNavbar);
    handleTransparentNavbar();

    return () => window.removeEventListener("scroll", handleTransparentNavbar);
  }, [dispatch, fixedNavbar]);

  async function signOut() {
    try {
        await Auth.signOut();
        window.location.href = '/authentication/sign-in'
    } catch (error) {
        console.log('error signing out: ', error);
    }
  }

  // Use event name in the breadcrumb if available
  const breadcrumbTitle = eventName || route[route.length - 1];

  return (
    <AppBar
      position={absolute ? "absolute" : navbarType}
      color="inherit"
      sx={(theme) => navbar(theme, { transparentNavbar, absolute, light })}
    >
      <Toolbar sx={(theme) => navbarContainer(theme)}>
        <SuiBox color="inherit" mb={{ xs: 1, md: 0 }} sx={(theme) => navbarRow(theme, { isMini })}>
          <Breadcrumbs icon="home" title={breadcrumbTitle} route={route} light={light} />
        </SuiBox>
        <SuiButton onClick={signOut} style={{ float: "right" }}>Log out</SuiButton>
      </Toolbar>
    </AppBar>
  );
}

DashboardNavbar.defaultProps = {
  absolute: false,
  light: false,
  isMini: false,
  eventName: "",
};

DashboardNavbar.propTypes = {
  absolute: PropTypes.bool,
  light: PropTypes.bool,
  isMini: PropTypes.bool,
  eventName: PropTypes.string,
};

export default DashboardNavbar;
